import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-custom-templates',
  templateUrl: './custom-templates.component.html',
  styleUrls: ['./custom-templates.component.css']
})
export class CustomTemplatesComponent implements OnInit {
  templates = [
    {
      'name': 'template1',
      'preview': '../../assets/images/download.jpg'
    },
    {
      'name': 'template2',
      'preview': '../../assets/images/download.jpg'
    },
    {
      'name': 'template3',
      'preview': '../../assets/images/download.jpg'
    },
    {
      'name': 'template4',
      'preview': '../../assets/images/download.jpg'
    }
  ]
  accountDetails: any;
  constructor(private router: Router,
    private activated_route: ActivatedRoute) { }

  ngOnInit() {
  this.accountDetails = this.activated_route.parent.snapshot.data['accountDetails'];
  }

  editTemplate(template) {
    this.router.navigate(['home', 'accounts', 'view', this.accountDetails.account.id, 'templates' , template.name]);
  }
}
